import { useState } from 'react'
import { CalendarClock } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import { toast } from 'sonner'

export function FutureDealModal({
  open,
  onClose,
  dealId: _dealId,
  onScheduled,
  saving = false,
}: {
  open: boolean
  onClose: () => void
  dealId: string
  onScheduled: (updates: { dataFechamentoPrevisto?: string; observacoes?: string }) => void | Promise<void>
  saving?: boolean
}) {
  const [data, setData] = useState('')
  const [hora, setHora] = useState('09:00')
  const [observacoes, setObservacoes] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleConfirm = async () => {
    if (!data) {
      toast.error('Selecione uma data')
      return
    }
    setSubmitting(true)
    const dataFechamentoPrevisto = hora ? `${data}T${hora}:00` : data
    try {
      await onScheduled({
        dataFechamentoPrevisto,
        observacoes: observacoes || undefined,
      })
      onClose()
    } catch {
      toast.error('Erro ao agendar')
    } finally {
      setSubmitting(false)
    }
  }

  const isSaving = saving || submitting

  return (
    <Modal open={open} onClose={onClose} title="Negociação Futura" size="sm">
      <div className="space-y-4">
        <p className="text-xs text-text-label">
          Agende este deal para reavaliação futura. Ele será movido para a aba "Negociação Futura".
        </p>

        <div className="grid grid-cols-2 gap-3">
          <div className="flex flex-col gap-1.5">
            <label className="text-[10px] text-text-label uppercase tracking-wider font-medium">Data</label>
            <input
              type="date"
              value={data}
              onChange={(e) => setData(e.target.value)}
              disabled={isSaving}
              className="w-full bg-white/[0.04] border border-white/[0.06] text-text-primary text-sm rounded-md px-3 py-2 outline-none focus:border-accent"
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-[10px] text-text-label uppercase tracking-wider font-medium">Hora</label>
            <input
              type="time"
              value={hora}
              onChange={(e) => setHora(e.target.value)}
              disabled={isSaving}
              className="w-full bg-white/[0.04] border border-white/[0.06] text-text-primary text-sm rounded-md px-3 py-2 outline-none focus:border-accent"
            />
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] text-text-label uppercase tracking-wider font-medium">Observações</label>
          <textarea
            value={observacoes}
            onChange={(e) => setObservacoes(e.target.value)}
            disabled={isSaving}
            rows={3}
            placeholder="Por que foi adiado? Qual o contexto?"
            className="w-full bg-white/[0.04] border border-white/[0.06] text-text-primary text-sm rounded-md px-3 py-2 outline-none focus:border-accent resize-none"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <Button variant="secondary" size="sm" onClick={onClose} disabled={isSaving} className="flex-1">
            Cancelar
          </Button>
          <Button
            variant="primary"
            size="sm"
            icon={<CalendarClock size={13} />}
            loading={isSaving}
            onClick={handleConfirm}
            className="flex-1"
          >
            Confirmar Agendamento
          </Button>
        </div>
      </div>
    </Modal>
  )
}
